var map = {
	"./404-bg.svg": "3bfe",
	"./SPlogo.svg": "d30c",
	"./action-blue.svg": "c5dd",
	"./action-dark.svg": "7d96",
	"./action-dark2.svg": "ed18",
	"./action-gray.svg": "efd7",
	"./action-white.svg": "12f2",
	"./activity.svg": "3f5a",
	"./add.svg": "3aba",
	"./bilo.png": "faf1",
	"./bitmap@2x.jpg": "c5f0",
	"./calendar.svg": "d2f5",
	"./check.svg": "5621",
	"./chevron-down-blue.svg": "be49",
	"./chevron-down-dark.svg": "fcb6",
	"./chevron-down-gray-dark копія.svg": "c0b6",
	"./chevron-down-gray-dark.svg": "997f",
	"./chevron-down-gray.svg": "604b",
	"./chevron-down-white.svg": "60c3",
	"./chevron-down.svg": "d234",
	"./chevron-left-blue.svg": "26e3",
	"./chevron-left-small-gray.svg": "ba1d",
	"./chevron-left-small.svg": "d230",
	"./chevron-left.svg": "fe52",
	"./chevron-right.svg": "0e59",
	"./chick-fil-a-logo.png": "5bd2",
	"./close-dark-old.svg": "d120",
	"./close-dark.svg": "4c58",
	"./close-gray.svg": "b589",
	"./close-white.svg": "7752",
	"./close.svg": "cf5a",
	"./co-pace-blueprint.png": "6073",
	"./co-pace-how.png": "0fcd",
	"./co-pace-logo.png": "e77a",
	"./colgate-logo.png": "5653",
	"./core-enterprises.svg": "b5a7",
	"./core-user.svg": "cac9",
	"./dashboard-placeholder.png": "3ab6",
	"./dashboard.png": "4aa5",
	"./default_startup_logo.svg": "07a3",
	"./drag-n-drop2-blue.svg": "1b16",
	"./drag-n-drop2.svg": "1693",
	"./dropdown-arrow-top.png": "6286",
	"./edit-white.svg": "4f4f",
	"./edit.svg": "5e3a",
	"./engagements.png": "63b1",
	"./global.png": "b4ed",
	"./greeting.png": "3de0",
	"./group-7.svg": "527c",
	"./group.svg": "93d8",
	"./home.svg": "f79a",
	"./icon-action-light.svg": "ad89",
	"./icon-action-more.svg": "fe70",
	"./icon-action-report.svg": "90f4",
	"./icon-actions-edit.svg": "4b07",
	"./icon-activity-blue.svg": "3065",
	"./icon-activity-call-active.svg": "4b84",
	"./icon-activity-call.svg": "034b",
	"./icon-activity-demo-active.svg": "7244",
	"./icon-activity-demo.svg": "222d",
	"./icon-activity-email-active.svg": "3c18",
	"./icon-activity-email.svg": "a6c2",
	"./icon-activity-meeting-active.svg": "cdfa",
	"./icon-activity-meeting.svg": "4916",
	"./icon-activity-news-active.svg": "5729",
	"./icon-activity-news.svg": "f1d9",
	"./icon-activity-note-active.svg": "d7c6",
	"./icon-activity-note.svg": "22c3",
	"./icon-add-dark.svg": "ec28",
	"./icon-add-light-blue.svg": "2280",
	"./icon-add-light-gray.svg": "9420",
	"./icon-add-light-white.svg": "5d1c",
	"./icon-add-light.svg": "9657",
	"./icon-add-need.svg": "9e1d",
	"./icon-add-red.svg": "36f4",
	"./icon-add-white.svg": "7a56",
	"./icon-add.svg": "818f",
	"./icon-admin-blue.svg": "bc92",
	"./icon-admin-light.svg": "51d4",
	"./icon-admin.svg": "f326",
	"./icon-ai-blue.svg": "2998",
	"./icon-ai-dark-blue.svg": "20b3",
	"./icon-ai-dark-blue2.svg": "888e",
	"./icon-ai-failed.svg": "9f25",
	"./icon-ai-generated-plate.png": "7c9e",
	"./icon-ai-generated.svg": "5e34",
	"./icon-ai-gray.svg": "2ffe",
	"./icon-ai-light-blue.svg": "c410",
	"./icon-ai-light-purple-gradient.svg": "fb59",
	"./icon-ai-light-purple.svg": "c7cc",
	"./icon-ai-purple.svg": "5d60",
	"./icon-ai-similar-blue.svg": "938b",
	"./icon-ai-similar.svg": "b1f4",
	"./icon-ai.svg": "5a5c",
	"./icon-approved.svg": "15cc",
	"./icon-archive-light.svg": "a181",
	"./icon-arrow-black.svg": "064d",
	"./icon-arrow-triangle-shadow2-yellow.svg": "9f47",
	"./icon-arrow-triangle-shadow2.svg": "ae02",
	"./icon-arrow-white.svg": "58c4",
	"./icon-arrow.svg": "a27a",
	"./icon-article.svg": "4422",
	"./icon-attach.png": "9246",
	"./icon-badge.png": "129a",
	"./icon-bin-light.svg": "910e",
	"./icon-binoculars-active.svg": "4a8d",
	"./icon-binoculars-light-gray.svg": "bfc9",
	"./icon-binoculars-light.svg": "58b2",
	"./icon-binoculars.svg": "964d",
	"./icon-blank.svg": "7f5f",
	"./icon-boolean-blue.svg": "10b3",
	"./icon-boolean.svg": "306f",
	"./icon-bottom-arrow.svg": "ebc3",
	"./icon-building-blue.svg": "8e86",
	"./icon-building-dark.svg": "c3aa",
	"./icon-building-green.svg": "b489",
	"./icon-building.svg": "23c3",
	"./icon-calendar.svg": "8cc4",
	"./icon-call-light-white.svg": "d371",
	"./icon-call-light.svg": "d223",
	"./icon-call.svg": "feeb",
	"./icon-categories.svg": "a60a",
	"./icon-category-light.svg": "e08c",
	"./icon-category.svg": "af72",
	"./icon-chat-active.svg": "2c35",
	"./icon-chat-blue-light.svg": "9bb3",
	"./icon-chat-blue.svg": "6fbb",
	"./icon-chat-light.svg": "1822",
	"./icon-chat.svg": "46e8",
	"./icon-check-gray.svg": "12a3",
	"./icon-check.svg": "2e14",
	"./icon-checkmark-blue.svg": "0af6",
	"./icon-checkmark-gray.svg": "d580",
	"./icon-checkmark-gray2.svg": "e7b9",
	"./icon-checkmark-purple.svg": "757c",
	"./icon-checkmark.svg": "218c",
	"./icon-checkmarklight-blue.svg": "3844",
	"./icon-clear-blue.svg": "31a5",
	"./icon-clear.svg": "3b59",
	"./icon-clients-blue.svg": "3f58",
	"./icon-clients-gray-dark.svg": "ea94",
	"./icon-clients-gray.svg": "380b",
	"./icon-clients-white.svg": "64da",
	"./icon-clients.svg": "d3f3",
	"./icon-clock-gray-light.svg": "6f69",
	"./icon-clock-light.svg": "a140",
	"./icon-clock-white.svg": "b649",
	"./icon-clock.svg": "992e",
	"./icon-close-blue.svg": "5977",
	"./icon-close-dark.svg": "b095",
	"./icon-close-light.svg": "1c80",
	"./icon-close-red-light.svg": "c98a",
	"./icon-close-red.svg": "c54a",
	"./icon-close-white.svg": "431a",
	"./icon-compose.svg": "5112",
	"./icon-copy-dark.svg": "55c7",
	"./icon-copy-light.svg": "3929",
	"./icon-copy-white.svg": "b15a",
	"./icon-copy.svg": "4e6a",
	"./icon-corporate.png": "9e96",
	"./icon-corporate2.svg": "6aa1",
	"./icon-critical.svg": "ba6c",
	"./icon-csv.svg": "b8b2",
	"./icon-custom-remove-dark.svg": "6e3e",
	"./icon-custom-remove.svg": "426c",
	"./icon-data-gray.svg": "a27f",
	"./icon-data-light.svg": "e29e",
	"./icon-data.svg": "f8d6",
	"./icon-delete-light-blue.svg": "4d22",
	"./icon-delete-light.svg": "62f1",
	"./icon-demo-light-white.svg": "f5a1",
	"./icon-demo-light.svg": "4f78",
	"./icon-demo.svg": "8cc5",
	"./icon-diagonal-up-arrow.svg": "3594",
	"./icon-double-arrow.svg": "9d43",
	"./icon-download-blue-dark.svg": "f739",
	"./icon-download-blue.svg": "2bc3",
	"./icon-download.png": "737b",
	"./icon-drag-n-drop-blue.svg": "e295",
	"./icon-drag-n-drop.svg": "6d68",
	"./icon-dropdown-light-white.svg": "9621",
	"./icon-dropdown-light.svg": "ebdf",
	"./icon-dropdown-white.svg": "72c4",
	"./icon-ecosystem-black.svg": "573f",
	"./icon-ecosystem-blue.svg": "eb20",
	"./icon-ecosystem-gray-dark.svg": "372a",
	"./icon-ecosystem-gray.svg": "c215",
	"./icon-ecosystem-graylight.svg": "0fdc",
	"./icon-ecosystem-green.svg": "5e02",
	"./icon-ecosystem-light-black.svg": "14bc",
	"./icon-ecosystem-light-blue.svg": "b5e0",
	"./icon-ecosystem-light.svg": "f6c7",
	"./icon-ecosystem-white.svg": "9888",
	"./icon-edit-blue.svg": "9afe",
	"./icon-edit-light-gray.svg": "7392",
	"./icon-edit-light-red.svg": "a094",
	"./icon-edit-light.svg": "10b2",
	"./icon-edit-prompt.svg": "ce91",
	"./icon-edit.svg": "d033",
	"./icon-email-light-white.svg": "4d3e",
	"./icon-email-light.svg": "ed76",
	"./icon-email.svg": "e092",
	"./icon-employees-light.svg": "96bb",
	"./icon-enter.png": "1b40",
	"./icon-enterprise-blue-small.svg": "9aa5",
	"./icon-enterprise-blue.svg": "8057",
	"./icon-enterprise-gray.svg": "8cb5",
	"./icon-enterprise-white.svg": "4e5c",
	"./icon-enterprise.svg": "95b0",
	"./icon-envelope-light.svg": "f593",
	"./icon-escalated.svg": "23bd",
	"./icon-export-blue.svg": "2e26",
	"./icon-export-csv.svg": "20c4",
	"./icon-export-light-blue.svg": "ab4d",
	"./icon-export-pdf-blue.svg": "90c4",
	"./icon-export-pdf.svg": "7fa3",
	"./icon-export-ppt.svg": "8848",
	"./icon-export-white.svg": "9eb0",
	"./icon-export.svg": "ee93",
	"./icon-eye-gray.svg": "1419",
	"./icon-eye-hide-gray.svg": "42a9",
	"./icon-eye-hide.svg": "0d0c",
	"./icon-eye-show.svg": "7aa2",
	"./icon-eye.svg": "dc1b",
	"./icon-facebook.svg": "6651",
	"./icon-favorite-light.svg": "31a4",
	"./icon-file-csv.svg": "b9ef",
	"./icon-file.svg": "2a00",
	"./icon-filter-light-blue.svg": "fb38",
	"./icon-folder-light-black.svg": "276a",
	"./icon-folder-light-blue.svg": "baea",
	"./icon-folder-light.svg": "52949",
	"./icon-folder-white.svg": "506d",
	"./icon-folder.svg": "5a38",
	"./icon-founded-light.png": "cbcb",
	"./icon-founded-light.svg": "6e67",
	"./icon-founded.svg": "680d",
	"./icon-funding-blue.svg": "8bda",
	"./icon-funding-green.svg": "0640",
	"./icon-funding-light.png": "b52c",
	"./icon-funding-light.svg": "c76e",
	"./icon-funding.svg": "3669",
	"./icon-gen-ai-gradient.svg": "df43",
	"./icon-gen-ai-off.svg": "df51",
	"./icon-gen-ai.svg": "de23",
	"./icon-general-edit.svg": "8c25",
	"./icon-globe-black.svg": "c5d6",
	"./icon-globe-light.svg": "8074",
	"./icon-globe.svg": "988a",
	"./icon-grid-blue.svg": "c9d7",
	"./icon-grid.svg": "3787",
	"./icon-heart.svg": "0e9f",
	"./icon-help-button.svg": "401d",
	"./icon-history.svg": "7a4a",
	"./icon-home-light.svg": "9b9e",
	"./icon-home-white.svg": "5df7",
	"./icon-home.svg": "49f5",
	"./icon-income-blue.svg": "8ebb",
	"./icon-income-light-blue.svg": "de8b",
	"./icon-income-light.png": "577f",
	"./icon-income.svg": "a3b4",
	"./icon-info-gray.svg": "a21c",
	"./icon-info-light-blue.svg": "65bd",
	"./icon-info-light.svg": "247b",
	"./icon-info-white-gray.svg": "a6e1",
	"./icon-info-white.svg": "cc95",
	"./icon-info.svg": "68b7",
	"./icon-information.svg": "590e",
	"./icon-intelligence.svg": "84bd",
	"./icon-invite.svg": "16e3",
	"./icon-knowledge.svg": "a250",
	"./icon-knowledge.webp": "e286",
	"./icon-leave.svg": "8077",
	"./icon-light-clock.svg": "4d5a",
	"./icon-light-ecosystem-white.svg": "617c",
	"./icon-light-startup-white.svg": "347a",
	"./icon-light-tag-blue.svg": "4a42",
	"./icon-light-tag.svg": "28c0",
	"./icon-light-tasks-white.svg": "8c9d",
	"./icon-light-text-blue.svg": "2c42",
	"./icon-light-text.svg": "1a33",
	"./icon-light-track-white.svg": "51ec",
	"./icon-light-tracker.svg": "0b78",
	"./icon-light-user-white.svg": "0aac",
	"./icon-light-user.svg": "e731",
	"./icon-lightbulb-gray.svg": "fc03",
	"./icon-lightbulb-light-blue.svg": "44eb",
	"./icon-lightbulb-light.svg": "058c",
	"./icon-lightbulb.svg": "6c94",
	"./icon-link.svg": "1c46",
	"./icon-list-mouse.svg": "cd76",
	"./icon-list-view-light.svg": "3b49",
	"./icon-list-view-opacity.svg": "bd884",
	"./icon-list-view.svg": "49cc",
	"./icon-list.svg": "dad4",
	"./icon-ln.svg": "e1a4",
	"./icon-location-blue.svg": "627b",
	"./icon-location-light.png": "f491",
	"./icon-location-light.svg": "1f35",
	"./icon-location.svg": "17c2",
	"./icon-logout.svg": "4d26",
	"./icon-logs-light.svg": "5abf",
	"./icon-magicglass-gradient.svg": "f9e6",
	"./icon-market-report.png": "8aee",
	"./icon-medium-blue.svg": "3c2d",
	"./icon-medium.svg": "28bd",
	"./icon-meeting.svg": "4c1b",
	"./icon-merge.svg": "91cd",
	"./icon-message.svg": "d154",
	"./icon-minimize.svg": "142e",
	"./icon-minus-blue.svg": "2b77",
	"./icon-minus.svg": "c5de",
	"./icon-modify.svg": "0137",
	"./icon-mouse.svg": "33df",
	"./icon-needs-ai.svg": "5a6e",
	"./icon-needs-arrow.svg": "01b5",
	"./icon-needs-ecosystem.svg": "7de2",
	"./icon-needs-search.svg": "b958",
	"./icon-news-gray.svg": "79df",
	"./icon-news.png": "b87f",
	"./icon-no-content.svg": "0a6a",
	"./icon-no-tasks.svg": "9aea",
	"./icon-no-template.svg": "3a9b1",
	"./icon-note-from.svg": "d218",
	"./icon-note-gray.svg": "140f",
	"./icon-note-light-blue.svg": "36b8",
	"./icon-note-light-gray.svg": "c166",
	"./icon-note-light-white.svg": "e14d",
	"./icon-note-light.svg": "05da",
	"./icon-note.svg": "f5e3",
	"./icon-notification-light-blue-off.svg": "c0a5",
	"./icon-notification-light-blue.svg": "2934",
	"./icon-notification-off.svg": "951c",
	"./icon-notification.svg": "184c",
	"./icon-notifications.svg": "800f",
	"./icon-noupdates.svg": "b651",
	"./icon-offset.svg": "8aa8",
	"./icon-open-popup-normal.svg": "8aa1",
	"./icon-open-popup-round.svg": "1401",
	"./icon-open-popup-transparent.svg": "9f74",
	"./icon-open-popup-white.svg": "854d",
	"./icon-open-popup.svg": "9e5d",
	"./icon-partnership.png": "706b",
	"./icon-partnership2.svg": "ce3f",
	"./icon-pdf.svg": "703b",
	"./icon-pending.svg": "a4c8",
	"./icon-pic.svg": "aff4",
	"./icon-pin.svg": "239c",
	"./icon-play-video.svg": "3c6d",
	"./icon-play.svg": "fc1c",
	"./icon-portfolio.svg": "40ac",
	"./icon-ppt.svg": "ea62",
	"./icon-premium.svg": "6c5a",
	"./icon-priority-critical.png": "1866",
	"./icon-priority-high.png": "9b75",
	"./icon-priority-low.png": "0cc6",
	"./icon-priority-medium.png": "423a",
	"./icon-privacy.svg": "a7ad",
	"./icon-profile-gray.svg": "940b",
	"./icon-profile.svg": "e19d",
	"./icon-pushpin-blue.svg": "5c5e",
	"./icon-pushpin.svg": "3c00",
	"./icon-question-blue.svg": "449d",
	"./icon-question-light-blue.svg": "045d",
	"./icon-question-mark-blue.svg": "ee5e",
	"./icon-quote.svg": "1157",
	"./icon-r-play-dark.svg": "be0a",
	"./icon-r-play.svg": "cc68",
	"./icon-radar-light.svg": "b6c7",
	"./icon-radar.svg": "d373",
	"./icon-rated.svg": "229c",
	"./icon-ratings-light.svg": "1371",
	"./icon-relations.svg": "58b1",
	"./icon-reload.svg": "8131",
	"./icon-remove-light.svg": "b9dd",
	"./icon-remove-red-bg.svg": "a07b",
	"./icon-remove-red.svg": "295b",
	"./icon-remove.svg": "a3ae",
	"./icon-report-creating.svg": "4a97",
	"./icon-report-light.svg": "f6c1",
	"./icon-report-triangle.svg": "7a54",
	"./icon-report.svg": "967c",
	"./icon-reporting-light.svg": "1deb",
	"./icon-reporting.svg": "476c",
	"./icon-resize.svg": "1a75",
	"./icon-save-light-blue.svg": "1671",
	"./icon-save-light.svg": "f6f6",
	"./icon-save-light2.svg": "30aa",
	"./icon-save.svg": "a139",
	"./icon-schedule-gray.svg": "361a",
	"./icon-schedule.svg": "90f6",
	"./icon-score0.svg": "7765",
	"./icon-score1.svg": "26ed",
	"./icon-score10.svg": "e32c",
	"./icon-score2.svg": "fc2d",
	"./icon-score3.svg": "6813",
	"./icon-score4.svg": "30fa",
	"./icon-score5.svg": "b3bd",
	"./icon-score6.svg": "53dd",
	"./icon-score7.svg": "27c1",
	"./icon-score8.svg": "b750",
	"./icon-score9.svg": "be0f",
	"./icon-search-black.svg": "011f",
	"./icon-search-blue.svg": "b8de",
	"./icon-search-button-purple.svg": "1b01",
	"./icon-search-button.png": "3651",
	"./icon-search-button.svg": "67d6",
	"./icon-search-gray.svg": "86cf",
	"./icon-search-light-blue.svg": "2e65",
	"./icon-search-lightgray.svg": "16e5",
	"./icon-search-white-slim.svg": "9125",
	"./icon-search-white.svg": "83fd",
	"./icon-select-arrow-white.svg": "179b",
	"./icon-select-arrow.svg": "e817",
	"./icon-select-blue.svg": "261b",
	"./icon-select-gray.svg": "945e",
	"./icon-select-white.svg": "f12b",
	"./icon-select.svg": "391c",
	"./icon-send.svg": "f4cb",
	"./icon-settings-light-blue.svg": "68c5",
	"./icon-settings-light.svg": "90eb",
	"./icon-settings.svg": "c57e",
	"./icon-share-light.svg": "21e1",
	"./icon-share-portfolio.png": "3ca6",
	"./icon-share-portfolio.svg": "a83e",
	"./icon-share.svg": "498d",
	"./icon-show.svg": "c4dd",
	"./icon-similar-blue.svg": "a604",
	"./icon-similar-gray.svg": "62a5",
	"./icon-similar-light-blue.svg": "ebe3",
	"./icon-sort-light.svg": "519f",
	"./icon-speed-0.svg": "fbe7",
	"./icon-speed-1.svg": "1e3f",
	"./icon-speed-10.svg": "2b4c",
	"./icon-speed-2.svg": "4259",
	"./icon-speed-3.svg": "94b3",
	"./icon-speed-4.svg": "6459",
	"./icon-speed-5.svg": "c964",
	"./icon-speed-6.svg": "0309",
	"./icon-speed-7.svg": "c260",
	"./icon-speed-8.svg": "a183",
	"./icon-speed-9.svg": "16be",
	"./icon-speed-base.svg": "22c9",
	"./icon-speed-light-simple.svg": "1ef2",
	"./icon-speed-light.svg": "5ac5",
	"./icon-speed.svg": "9f26e",
	"./icon-star-light.svg": "3b83",
	"./icon-start-ups-blue.svg": "2bfa",
	"./icon-startup-gray.svg": "78a6",
	"./icon-startup-light-blue.svg": "8434",
	"./icon-startup-light-gray-dark.svg": "7f93",
	"./icon-startup-light-gray.svg": "1e61",
	"./icon-startup-light-white.svg": "789b",
	"./icon-startup-light.svg": "aea3",
	"./icon-startup-white.svg": "e5f8",
	"./icon-startup.png": "bd97",
	"./icon-startups-gray.svg": "47a6",
	"./icon-startups-light.png": "0573",
	"./icon-startups-white.svg": "9712",
	"./icon-sync.svg": "1942",
	"./icon-tag-light-blue.svg": "0286",
	"./icon-tag-light.svg": "a645",
	"./icon-tag.svg": "3239",
	"./icon-task-blue.svg": "af69",
	"./icon-task.svg": "f679",
	"./icon-tasks-blue.svg": "c7e2",
	"./icon-tasks.svg": "9b46",
	"./icon-team-light-blue.svg": "8e57",
	"./icon-team-light.svg": "5fad",
	"./icon-team-white.svg": "3ac3",
	"./icon-team.svg": "40c1",
	"./icon-template-light-blue.svg": "e01b",
	"./icon-text-document.webp": "1db8",
	"./icon-thumbs-down-fill.svg": "4617",
	"./icon-thumbs-down-full.svg": "4668",
	"./icon-thumbs-up-blue.svg": "e976",
	"./icon-thumbs-up-fill.svg": "6103",
	"./icon-thumbs-up-full.svg": "406d",
	"./icon-thumbs-up.svg": "d3ec",
	"./icon-tool.svg": "536a",
	"./icon-top-arrow-opacity.svg": "0d93",
	"./icon-top-arrow.svg": "bcf0",
	"./icon-track-blue.svg": "bc49",
	"./icon-track-dark.svg": "20ba",
	"./icon-track-gray.svg": "183c",
	"./icon-track-graylight.svg": "4d51",
	"./icon-track-light-blue-horizontal.svg": "b484",
	"./icon-track-light-blue.svg": "0577",
	"./icon-track-light-horizontal.svg": "939c",
	"./icon-track-light.svg": "8fbb",
	"./icon-track-white.svg": "c4bb",
	"./icon-tracker-gray-light.svg": "87b8",
	"./icon-tracker.png": "3306",
	"./icon-trash-can.svg": "54f0",
	"./icon-trends.png": "a490",
	"./icon-trends2.svg": "0abe",
	"./icon-triangle.svg": "ea43",
	"./icon-twitter.svg": "5304",
	"./icon-user-blue.svg": "359b",
	"./icon-user-gray.svg": "bb45",
	"./icon-user-white.svg": "1551",
	"./icon-user.svg": "e80b",
	"./icon-users-gray.svg": "40de",
	"./icon-valuation.svg": "8403",
	"./icon-vc.svg": "8259",
	"./icon-video-play.svg": "4acb",
	"./icon-view-light.svg": "1d5f",
	"./icon-view.svg": "08f3",
	"./icon-walkthrough.svg": "7680",
	"./icon-watched.svg": "13bc",
	"./icon-wrench.svg": "71aa",
	"./icon-x-gray.svg": "2487",
	"./icon-x.svg": "4340",
	"./icon-y.svg": "3f67",
	"./icon-youtube.svg": "a1cf",
	"./icons-filter-blue.svg": "e29b",
	"./icons-filter-light.svg": "38fc",
	"./icons-filter.svg": "36b3",
	"./icons-profile.svg": "6d67",
	"./icons-remove.svg": "3264",
	"./icons-right-arrow.svg": "2519",
	"./linkedin.svg": "a79e",
	"./logo-RTX.png": "b75e",
	"./logo-bloomberg.png": "859c",
	"./logo-entrepreneur.png": "1fd0",
	"./logo-inc.png": "ef08",
	"./logo-mc.svg": "5a8f",
	"./logo-on-white.png": "012f",
	"./logo-pdf-link.svg": "4bc8",
	"./logo-rtx.svg": "26f1",
	"./logo-travellers.png": "f4d3",
	"./logo-upstart.png": "5a49",
	"./logo-usnews.png": "3dc0",
	"./logo.png": "013a",
	"./logo.svg": "4d87",
	"./lopez.png": "f154",
	"./manager.png": "673b",
	"./minimize.svg": "1dee",
	"./modal-previews/activity-feed-preview.png": "8bdf",
	"./modal-previews/add-startup-preview.png": "5211",
	"./modal-previews/analyst-hours.png": "d8b9",
	"./modal-previews/fields-history-preview.png": "caec",
	"./modal-previews/img1.png": "3c48",
	"./notify-icon-error.svg": "5593",
	"./notify-icon-warn.svg": "aee4",
	"./popover-arrow.png": "7240",
	"./rectangle-gray.svg": "df66",
	"./rectangle.svg": "f76d",
	"./save.svg": "2463",
	"./search-button.svg": "1e75",
	"./search-dark.svg": "95f3",
	"./search.svg": "8ebbf",
	"./sp-logo.svg": "0925",
	"./sp-popup-bg.png": "5217",
	"./star-full.svg": "f8ff",
	"./star-yellow.svg": "788f",
	"./star.svg": "1098",
	"./start-ups-black.svg": "abcd",
	"./start-ups-gray.svg": "35b1",
	"./start-ups-green.svg": "4cfb",
	"./start-ups.svg": "0b1b",
	"./startup-info-employes-gray.svg": "9017",
	"./startup-info-employes.svg": "e668",
	"./synapse-homepage.webp": "5047",
	"./synapse-homepage1.png": "0731",
	"./synapse-homepage2.png": "970d",
	"./synapse-homepage3.png": "dc91",
	"./time-badge-bronze.svg": "3d1f",
	"./time-badge-gold.svg": "0238",
	"./time-badge-platinum.svg": "f5d7",
	"./time-badge-silver.svg": "4adc",
	"./time-badge-start.svg": "76968",
	"./tracker-report-templates-previews/comprehensive-report.jpeg": "281c",
	"./tracker-report-templates-previews/deep-dive-report-old.png": "d6bc",
	"./tracker-report-templates-previews/deep-dive-report.png": "c555",
	"./tracker-report-templates-previews/high-level-overview.jpeg": "b62a",
	"./tracker-report-templates-previews/insights-report-background.png": "dbf1",
	"./tracker-report-templates-previews/summary-report.png": "047b",
	"./tracker-report-templates-previews/summary-report1.png": "224b",
	"./user1.png": "ca61",
	"./user2.png": "b0cd",
	"./viva.png": "6529",
	"./warning-red.svg": "2dd2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6b6a";